import { CompanyUserStatisticQuery } from "@generated/graphql";
import { Stack } from "@mui/material";
import { useState } from "react";
import TeamFilters from "./components/TeamFilters";
import TeamHeader from "./components/TeamHeader";
import InviteEmployeeModal from "./components/InviteEmployeeModal";
import TeamMembersTable from "./components/TeamMembersTable";
import TeamStats from "./components/TeamStats";
import { TeamMembersFilter } from "./components/tableConfig/types";

type TeamTabProps = {
  statistic: CompanyUserStatisticQuery["companyUserStatistic"] | undefined;
  isStatisticLoading: boolean;
};

const TeamTab = ({ statistic, isStatisticLoading }: TeamTabProps) => {
  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
  const [teamMembersFilter, setTeamMembersFilter] = useState<TeamMembersFilter>({});

  return (
    <Stack spacing={3}>
      <TeamHeader onInvite={() => setIsInviteModalOpen(true)} />
      <TeamStats
        statistic={statistic}
        isLoading={isStatisticLoading}
      />
      <TeamFilters onFilterChange={setTeamMembersFilter} />
      <TeamMembersTable filter={teamMembersFilter} />
      <InviteEmployeeModal
        open={isInviteModalOpen}
        onClose={() => setIsInviteModalOpen(false)}
      />
    </Stack>
  );
};

export default TeamTab;
